export default __webpack_public_path__ + "static/media/ILPlatform_Programme8-11.47b3253d.png";